import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import './style.css';
import { setCity } from 'components/emissions-demo/actions';
import { Mobile } from 'components/responsive';

class TimeSeries extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { isOpen: true };
  }

  onToggleCollapse = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen })
  }

  render() {
    const { isOpen } = this.state;
    const { timeSeries, city, pollutant, selectedComparingYear, selectedComparingMonth } = this.props;
    setCity()


    return (
      < div className={classnames({
        'c-time-series': true,
        '-compareOpened': selectedComparingYear || selectedComparingMonth
      })} >
        {timeSeries && city && pollutant &&
          <Fragment >
            <div className={classnames({
              'time-series-content': true,
              '-opened': isOpen
            })}>
              <h4 className="time-series-title">Time series | {city.label}</h4>
              <div className="time-series-chart">
                <Mobile>
                  {(isMobile) => (
                    <ResponsiveContainer width='99%' aspect={2}>
                      <LineChart
                        data={timeSeries}
                        margin={{
                          top: 5, right: 0, left: -30, bottom: 5,
                        }}
                        padding={{ right: 15 }}
                      >
                        <CartesianGrid vertical={false} strokeDasharray="0" />
                        <XAxis
                          dataKey={"date"}
                          interval={isMobile ? 'preserveStartEnd' : 0}
                        />
                        <YAxis
                          dataKey="value"
                          fill="white"
                          minTickGap={0}
                          interval={0}
                        />
                        <Tooltip payload={timeSeries}/>
                        <Line dataKey="value" fill="white" />
                      </LineChart>
                    </ResponsiveContainer>
                  )}
                </Mobile>
              </div>

            </div>
            <button
              type="button"
              className={classnames({
                'time-series-btn': true,
                '-opened': isOpen
              })}
              onClick={this.onToggleCollapse}>
              <span>{isOpen ? 'Collapse' : 'Time series'}</span>
            </button>

          </Fragment>
        }
      </div>
    )
  }
}


const optionPropType = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

TimeSeries.propTypes = {
  selectedYear: optionPropType,
  selectedMonth: optionPropType,
};

TimeSeries.defaultProps = { selectedYear: null, selectedMonth: null };

export default TimeSeries;



// WEBPACK FOOTER //
// ./src/components/emissions-demo/components/time-series/component.js